import { render } from "./category-wizard-mobile.vue?vue&type=template&id=ac625086&scoped=true&ts=true"
import script from "./category-wizard-mobile.vue?vue&type=script&lang=ts"
export * from "./category-wizard-mobile.vue?vue&type=script&lang=ts"

import "./category-wizard-mobile.vue?vue&type=style&index=0&id=ac625086&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac625086"]])

export default __exports__